export default __webpack_public_path__ + "static/media/arrowGreen.a3ebae20.svg";